// @flow
import {
  resourceReducer,
} from 'redux-resource';
import {
  includedResources,
  reset,
} from 'redux-resource-plugins';

import {
  worklogTypes,
} from 'chronos-constants';

import {
  allListPlugin,
} from './plugins';


const resources = {
  users: resourceReducer('users', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        users: [],
        all: [],
      },
    },
  }),
  jqlFilters: resourceReducer('jqlFilters', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        jqlFilters: [],
        all: [],
      },
    },
  }),
  issueTypes: resourceReducer('issueTypes', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        issueTypes: [],
        all: [],
      },
    },
  }),
  issueStatuses: resourceReducer('issueStatuses', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        issueTypes: [],
        all: [],
      },
    },
  }),
  issuesFields: resourceReducer('issuesFields', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        issuesFields: [],
        all: [],
      },
    },
  }),
  components: resourceReducer('components', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        components: [],
        all: [],
      },
    },
  }),
  sprints: resourceReducer('sprints', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        sprints: [],
        all: [],
      },
    },
  }),
  boards: resourceReducer('boards', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        boards: [],
        all: [],
      },
    },
  }),
  versions: resourceReducer('versions', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        versions: [],
        all: [],
      },
    },
  }),
  projects: resourceReducer('projects', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        projects: [],
        all: [],
      },
    },
  }),
  worklogTypes: resourceReducer('worklogTypes', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      resources: (
        worklogTypes.reduce(
          (acc, worklogType) => ({
            [worklogType.id]: worklogType,
            ...acc,
          }),
          {},
        )
      ),
      lists: {
        worklogTypes: worklogTypes.map(w => w.id),
        all: [],
      },
    },
  }),
  worklogs: resourceReducer('worklogs', {
    plugins: [
      includedResources,
      allListPlugin,
      reset,
    ],
    initialState: {
      lists: {
        worklogs: [],
        all: [],
      },
    },
  }),
  issues: resourceReducer('issues', {
    plugins: [
      includedResources,
      allListPlugin,
    ],
    initialState: {
      lists: {
        epics: [],
        issues: [],
        all: [],
      },
    },
  }),
  activities: resourceReducer('activities', {
    plugins: [
      allListPlugin,
    ],
    initialState: {
      lists: {
        activities: [],
        all: [],
      },
    },
  }),
};

export default resources;
